import './rxjs-extensions';

import { NgModule, ModuleWithProviders } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalModule } from '../modal/modal.module';

import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
//import { SharedAppModule } from '../../shared.module';

import { LookupEditComponent } from './lookupedit.component';
import { LookupEditRoutingModule } from './lookupedit.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    LookupEditRoutingModule,
    ReactiveFormsModule,
    //SharedAppModule,
  ],
  exports: [
    LookupEditComponent
  ],
  declarations: [
    LookupEditComponent
  ],
  providers: [
    GenericdatasetService
  ]
})
export class LookupEditModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LookupEditModule,
      providers: [GenericdatasetService]
    };
  }
}
